export enum ButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Text = 'text',
  Round = 'round',
}
